module.exports = __webpack_public_path__ + "static/img/9.7bcfa25.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/sp/9.png
// module id = 9Mgz
// module chunks = 0